module.exports = __webpack_public_path__ + "img/cpzx.d260ae85.png";